import { jwtDecode } from "jwt-decode";

// ----------------------------------------------------------------------

const isValidToken = (accessToken: string) => {
	if (!accessToken) {
		return false;
	}

	const decoded = jwtDecode<{ exp: number }>(accessToken);
	const currentTime = Date.now() / 1000;

	return decoded.exp > currentTime;
};

export const decodeAccessToken = (accessToken: string) => {
	try {
		const decoded = jwtDecode<{
			redirectUri: string;
			maintenance: boolean;
		}>(accessToken);
		return { redirectUri: decoded.redirectUri, maintenance: decoded.maintenance };
	} catch (error) {
		console.log(error);
		return { redirectUri: "", maintenance: false };
	}
};

export { isValidToken };
